import React, { useEffect, useRef, useState } from 'react';
import { Anchor, UserCheck, Wrench } from 'lucide-react';

const SafetyStandards = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Repeat animation every 5 seconds
  useEffect(() => {
    if (isVisible) {
      const interval = setInterval(() => {
        setIsVisible(false);
        setTimeout(() => setIsVisible(true), 100);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [isVisible]);

  return (
    <section ref={sectionRef} className="-mt-1 pt-20 md:pt-28 pb-20 relative overflow-hidden bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Two Column Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          
          {/* Left Side - Text Content Only */}
          <div className="flex flex-col items-center space-y-6">
            {/* Text Content */}
            <div className="text-center">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight text-white">
                WE FOLLOW
              </h2>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight text-yellow-400 mt-2">
                SANZ STANDARDS
              </h2>
              <p className="text-base md:text-lg text-white font-bold mt-4">
                AUSTRALIA AND NEW ZEALAND
              </p>
            </div>
          </div>

          {/* Right Side - Contact Style Layout with Pop-out Animation */}
          <div className="flex flex-col space-y-6">
            {/* Premium Safety Gear */}
            <div className={`flex items-center space-x-4 ${isVisible ? 'animate-pop-out' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: '#00A8E1' }}>
                  <Anchor size={28} className="text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-lg md:text-3xl font-black whitespace-nowrap text-white">
                  PREMIUM SAFETY GEAR
                </h3>
              </div>
            </div>

            {/* Certified Instructors */}
            <div className={`flex items-center space-x-4 ${isVisible ? 'animate-pop-out' : 'opacity-0'}`} style={{ animationDelay: '0.4s' }}>
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: '#00A8E1' }}>
                  <UserCheck size={28} className="text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-lg md:text-3xl font-black whitespace-nowrap text-white">
                  CERTIFIED INSTRUCTORS
                </h3>
              </div>
            </div>

            {/* Daily Maintenance */}
            <div className={`flex items-center space-x-4 ${isVisible ? 'animate-pop-out' : 'opacity-0'}`} style={{ animationDelay: '0.6s' }}>
              <div className="flex-shrink-0">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ backgroundColor: '#00A8E1' }}>
                  <Wrench size={28} className="text-white" />
                </div>
              </div>
              <div>
                <h3 className="text-lg md:text-3xl font-black whitespace-nowrap text-white">
                  DAILY MAINTENANCE
                </h3>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default SafetyStandards;